import { render, staticRenderFns } from "./Products_Detail.vue?vue&type=template&id=1924dbe6&scoped=true"
import script from "./Products_Detail.vue?vue&type=script&lang=js"
export * from "./Products_Detail.vue?vue&type=script&lang=js"
import style0 from "./Products_Detail.vue?vue&type=style&index=0&id=1924dbe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1924dbe6",
  null
  
)

export default component.exports